import classNames from 'classnames';

import './Heading.scss';

const Heading = ({ size, h, theme, background, children }) => {
    const componentClasses = classNames('Heading', {
            'Heading--dark': background === 'dark',
        }),
        headingClasses = classNames('heading', {
            'heading--large': size === 'large',
            'heading--white': theme === 'dark',
        }),
        Elem = h ? h : 'h2';

    return (
        <div className={componentClasses}>
            <div className="container">
                <Elem className={headingClasses}>{children}</Elem>
            </div>
        </div>
    );
};

export default Heading;
